import React from 'react';
import Carousel from '../Carousel/Carousel';
import Navbar from '../Shared/Navbar/Navbar';

const Header = () => {
    return (
        <div>
            <Navbar/>
            <Carousel/>
        </div>

    );
};

export default Header;